module.exports = __webpack_public_path__ + "img/arrow-back.09dbc788.svg";